import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';


/**
 * Base UI Components to be imported, 
 * this mandatory to be included so that the View Module Pages can be rendered via baseUI
 */
import { BaseUIContainerComponent } from '../../../BaseFramework/base-ui/base-ui-container/base-ui-container.component'
import { AppLayoutComponent } from '../../../BaseFramework/base-ui/app-layout/app-layout.component'
////BASEUI Modules End

import { WorkbenchComponent } from './workbench/workbench.component';
// import { UnderWritingAuthenticationGuard } from '../underwriting-guards';


var routeList = [
    {
        path: 'workbench',
        component: WorkbenchComponent,
        data: {
            breadcrumb: 'Workbench',
            inboxType: 'workbench'
        },
    },
    {
        path: 'deworkbench',
        component: WorkbenchComponent,
        data: {
            breadcrumb: 'Workbench',
            inboxType: 'workbench'
        },
    },
    {
        path: 'uwworkbench',
        component: WorkbenchComponent,
        data: {
            breadcrumb: 'Workbench',
            inboxType: 'workbench'
        },
    },
    {
        path: 'enquiry',
        component: WorkbenchComponent,
        data: {
            breadcrumb: 'Enquiry',
            inboxType: 'enquiry'
        },
    },
    
];

const routes: Routes = [
    ...routeList
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
    providers: []
})

export class InboxRoutingModule { } 
